/**
 * useRolNavigation — resuelve dinámicamente Mi Cockpit y Mi Bandeja según el rol.
 *
 * Logic:
 *  - isAdmin (CEO/Director/Fundador) → /cockpit/ceo + /inbox-hub (todos)
 *  - isCOO                            → /cockpit/coo + /inbox-hub (todos)
 *  - isCFO                            → /finanzas + /finanzas
 *  - isCPC (René)                     → /coberturas/control + /agent-inbox
 *  - COM / SMM (rol principal)        → /com/cockpit + /com/inbox
 *  - isCuenta (EC)                    → /ec/cockpit + /ec/inbox
 *  - isCCC                            → /ccc/cockpit + /ccc/inbox
 *  - isCM (COM)                       → /com/cockpit + /com/inbox
 *  - isEspecialista (CPC etc.)        → /cpc/cockpit + /agent-inbox
 *  - Resto (junior, sin rol)          → /inicio + /agent-inbox
 */

import { useAuth } from "../context/AuthContext.jsx";

export function useRolNavigation() {
  const { isAdmin, isCOO, isCFO, isCPC, rolBase, isCuenta, isCCC, isCM, isEspecialista } = useAuth();

  let miCockpit = "/inicio";
  let miCockpitLabel = "Mi Cockpit";
  let miBandeja = "/agent-inbox";
  let miBandejaLabel = "Mi Bandeja";

  if (isAdmin) {
    miCockpit = "/cockpit/ceo";
    miCockpitLabel = "Cockpit CEO";
    miBandeja = "/inbox-hub";
    miBandejaLabel = "Bandeja unificada";
  } else if (isCOO) {
    miCockpit = "/cockpit/coo";
    miCockpitLabel = "Cockpit COO";
    miBandeja = "/inbox-hub";
    miBandejaLabel = "Bandeja unificada";
  } else if (isCFO) {
    miCockpit = "/finanzas";
    miCockpitLabel = "Cockpit Financiero";
    miBandeja = "/finanzas";
    miBandejaLabel = "Finanzas";
  } else if (isCPC) {
    // CPC (René) no tenía cockpit: el de producción era para especialistas y leía una tabla vieja.
    miCockpit = "/coberturas/control";
    miCockpitLabel = "Cockpit Producción";
    miBandeja = "/agent-inbox";
    miBandejaLabel = "Mi Bandeja";
  } else if (rolBase === "com" || rolBase === "smm") {
    // El rol PRINCIPAL manda: Nic o Eduardo tienen EC como rol extra pero su trabajo es publicar y revisar.
    miCockpit = "/com/cockpit";
    miCockpitLabel = "Cockpit COM";
    miBandeja = "/com/inbox";
    miBandejaLabel = "Bandeja COM";
  } else if (isCuenta) {
    miCockpit = "/ec/cockpit";
    miCockpitLabel = "Cockpit EC";
    miBandeja = "/ec/inbox";
    miBandejaLabel = "Bandeja EC";
  } else if (isCCC) {
    miCockpit = "/ccc/cockpit";
    miCockpitLabel = "Cockpit CCC";
    miBandeja = "/ccc/inbox";
    miBandejaLabel = "Bandeja CCC";
  } else if (isCM) {
    miCockpit = "/com/cockpit";
    miCockpitLabel = "Cockpit COM";
    miBandeja = "/com/inbox";
    miBandejaLabel = "Bandeja COM";
  } else if (isEspecialista) {
    // Creativos: lo suyo es su día. Foto y audiovisual, además, las coberturas de hoy (antes recibían el cockpit del CPC).
    const enCampo = ["fotógrafo", "fotografo", "audiovisual"].includes(rolBase);
    miCockpit = enCampo ? "/campo" : "/mi-pipeline";
    miCockpitLabel = enCampo ? "Hoy en campo" : "Mi Pipeline";
    miBandeja = "/agent-inbox";
    miBandejaLabel = "Mi Bandeja";
  }

  return { miCockpit, miCockpitLabel, miBandeja, miBandejaLabel };
}
